(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroes = document.querySelectorAll('[data-collection-hero]');

    heroes.forEach((hero) => {
      const scrollBtn = hero.querySelector('[data-hero-scroll]');
      if (scrollBtn) {
        scrollBtn.addEventListener('click', () => {
          const next = hero.nextElementSibling;
          const top = next
            ? next.getBoundingClientRect().top + window.scrollY
            : hero.offsetHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        });
      }

      const isOverlay = hero.classList.contains('collection-hero--layout-overlay');
      if (!isOverlay) return;

      const media = hero.querySelector('[data-hero-media]');
      if (!media) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let ticking = false;
      const update = () => {
        const rect = hero.getBoundingClientRect();
        const viewH = window.innerHeight;
        if (rect.bottom < 0 || rect.top > viewH) { ticking = false; return; }
        const progress = Math.max(Math.min(-rect.top / hero.offsetHeight, 1), 0);
        media.style.transform = `translate3d(0, ${progress * 60}px, 0)`;
        ticking = false;
      };
      const onScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    var T = window.SPL_WL_I18N || {};

    var KEY = 'splendido_wishlist';
    var loader   = root.querySelector('[data-wishlist-loader]');
    var grid     = root.querySelector('[data-wishlist-grid]');
    var empty    = root.querySelector('[data-wishlist-empty]');
    var browse   = root.querySelector('[data-wishlist-browse]');
    var hint     = root.querySelector('[data-wishlist-hint]');
    var toolbar  = root.querySelector('[data-wishlist-toolbar]');
    var bulkBar  = root.querySelector('[data-wishlist-bulk]');
    var bulkBtn  = root.querySelector('[data-wishlist-bulk-add]');
    var bulkCount = root.querySelector('[data-wishlist-bulk-count]');
    var sortSel  = root.querySelector('[data-wishlist-sort]');
    var shareBtn = root.querySelector('[data-wishlist-share]');
    var clearBtn = root.querySelector('[data-wishlist-clear]');
    var countEl  = root.querySelector('[data-wishlist-count]');
    var countNum = root.querySelector('[data-wishlist-count-number]');
    var toast    = root.querySelector('[data-wishlist-toast]');
    var currency = root.getAttribute('data-currency') || 'EUR';
    var locale   = root.getAttribute('data-locale') || 'de';

    /* In-memory cache of fetched product JSON (handle -> product) */
    var products = [];
    var byHandle = {};
    var toastTimer = null;

    /* ===== Storage helpers ===== */
    function getList() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function setList(arr) {
      try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
      if (typeof window.dispatchEvent === 'function') {
        /* SPLENDIDO 2026-08-03: l'evento 'storage' sintetico non ha `key`, quindi wishlist-toggle.js
           lo scartava e il contatore nell'intestazione restava indietro. Ora si annuncia con
           l'evento dedicato (quello sintetico resta per retrocompatibilità). */
        try { window.dispatchEvent(new CustomEvent('splendido:wishlist:changed', { detail: { list: arr } })); } catch (e) {}
        try { window.dispatchEvent(new Event('storage')); } catch (e) {}
      }
    }

    /* ===== SPLENDIDO: Import via ?list= (Teilen-Link / Geraetewechsel) =====
       Der Teilen-Button kodiert die Liste in die URL; beim Oeffnen wird sie
       hier in localStorage uebernommen (Merge, ohne Duplikate). */
    (function importFromUrl() {
      try {
        var sp = new URLSearchParams(window.location.search);
        var raw = sp.get('list');
        if (!raw) return;
        var incoming = raw.split(',').map(function (s) {
          try { return decodeURIComponent(s).trim().toLowerCase(); } catch (e) { return ''; }
        }).filter(function (s) { return /^[a-z0-9][a-z0-9-]*$/.test(s); });
        var list = getList();
        var added = 0;
        incoming.forEach(function (h) {
          if (list.indexOf(h) === -1) { list.push(h); added++; }
        });
        if (added > 0) setList(list);
        sp.delete('list');
        try {
          var qs = sp.toString();
          window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
        } catch (e) {}
        if (added > 0) showToast((T.list_imported || 'Wunschliste übernommen'), 'success');
      } catch (e) {}
    })();

    /* ===== Formatting ===== */
    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }
    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* ===== Toast ===== */
    function showToast(msg, type) {
      if (!toast) return;
      toast.hidden = false;
      toast.className = 'wishlist-toast' + (type ? ' wishlist-toast--' + type : '');
      toast.textContent = msg;
      /* Force reflow then animate in */
      void toast.offsetWidth;
      toast.classList.add('is-visible');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.hidden = true; }, 240);
      }, 2400);
    }

    /* ===== Card rendering ===== */
    function renderCard(p) {
      var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
      if (img) {
        var sep = img.indexOf('?') >= 0 ? '&' : '?';
        img = img.replace(/[?&](width|format)=[^&]*/g, '').replace(/\?&/, '?').replace(/&$/, '') + sep + 'width=600&format=webp';
      }
      var variants = Array.isArray(p.variants) ? p.variants : [];
      var available = !!p.available;
      var multiVariant = variants.length > 1;
      var firstAvail = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) { firstAvail = variants[i]; break; }
      }

      /* Price block */
      var priceHtml;
      if (p.compare_at_price && p.compare_at_price > p.price) {
        priceHtml = '<span class="wishlist-card__price-sale">' + money(p.price) + '</span>' +
                    '<span class="wishlist-card__price-compare">' + money(p.compare_at_price) + '</span>';
      } else {
        priceHtml = money(p.price);
      }

      /* Badges */
      var badges = '';
      if (p.compare_at_price && p.compare_at_price > p.price) {
        badges += '<span class="wishlist-card__badge wishlist-card__badge--sale">Sale</span>';
      }
      if (!available) {
        badges += '<span class="wishlist-card__badge wishlist-card__badge--soldout">' + (T.sold_out || 'Ausverkauft') + '</span>';
      }
      var badgesHtml = badges ? '<div class="wishlist-card__badges">' + badges + '</div>' : '';

      /* Primary action: In den Warenkorb (single-variant available) | Optionen wählen (multi) | Ausverkauft (none) */
      var primary;
      if (!available || !firstAvail) {
        primary = '<button type="button" class="wishlist-card__btn" disabled>' + (T.sold_out || 'Ausverkauft') + '</button>';
      } else if (multiVariant) {
        primary = '<a href="' + escapeHtml(p.url) + '" class="wishlist-card__btn" data-wishlist-options>' +
                    '<span>' + (T.choose_options || 'Optionen wählen') + '</span>' +
                  '</a>';
      } else {
        primary = '<button type="button" class="wishlist-card__btn" data-wishlist-add data-variant-id="' + firstAvail.id + '">' +
                    '<span>' + (T.add_to_cart || 'In den Warenkorb') + '</span>' +
                  '</button>';
      }

      /* Secondary: Genauer ansehen */
      var secondary = '<a href="' + escapeHtml(p.url) + '" class="wishlist-card__btn wishlist-card__btn--secondary">' +
                       '<span>' + (T.view_closer || 'Genauer ansehen') + '</span>' +
                     '</a>';

      return (
        '<article class="wishlist-card" data-handle="' + escapeHtml(p.handle) + '">' +
          badgesHtml +
          '<a href="' + escapeHtml(p.url) + '" class="wishlist-card__media">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' + escapeHtml(p.handle) + '" aria-label="Entfernen">' +
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<div class="wishlist-card__info">' +
            '<a href="' + escapeHtml(p.url) + '" class="wishlist-card__title">' + escapeHtml(p.title) + '</a>' +
            '<p class="wishlist-card__price">' + priceHtml + '</p>' +
            '<div class="wishlist-card__actions">' +
              primary +
              secondary +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }

    /* ===== Sorting ===== */
    function sortProducts(arr, mode) {
      var copy = arr.slice();
      if (mode === 'price-asc')  copy.sort(function (a, b) { return a.price - b.price; });
      else if (mode === 'price-desc') copy.sort(function (a, b) { return b.price - a.price; });
      else if (mode === 'name')  copy.sort(function (a, b) { return String(a.title).localeCompare(String(b.title), locale); });
      else { /* recent = original list order */ }
      return copy;
    }

    /* ===== State machines ===== */
    function showEmpty() {
      if (loader) loader.hidden = true;
      if (grid) grid.hidden = true;
      if (empty) empty.hidden = false;
      if (browse) browse.hidden = true;
      if (hint) hint.hidden = true;
      if (toolbar) toolbar.hidden = true;
      if (bulkBar) bulkBar.hidden = true;
      if (countEl) countEl.hidden = true;
    }

    function renderGrid(list) {
      if (!grid) return;
      grid.hidden = false;
      grid.innerHTML = list.map(renderCard).join('');

      if (empty) empty.hidden = true;
      if (browse) browse.hidden = false;
      if (hint) hint.hidden = false;
      if (toolbar) toolbar.hidden = false;
      if (countEl && countNum) { countEl.hidden = false; countNum.textContent = list.length; }

      /* Bulk button: count of available single-variant products */
      var bulkable = list.filter(function (p) {
        return p.available && Array.isArray(p.variants) && p.variants.length === 1 && p.variants[0].available;
      });
      if (bulkBar) {
        if (bulkable.length > 0) {
          bulkBar.hidden = false;
          if (bulkCount) bulkCount.textContent = '(' + bulkable.length + ')';
        } else {
          bulkBar.hidden = true;
        }
      }
    }

    function load() {
      var list = getList();
      if (!list.length) { showEmpty(); return; }
      if (loader) loader.hidden = false;
      if (grid) grid.hidden = true;
      Promise.all(list.map(function (h) {
        return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(h) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (results) {
        if (loader) loader.hidden = true;
        var valid = [];
        var validHandles = [];
        for (var i = 0; i < results.length; i++) {
          var p = results[i];
          if (p && p.handle) { valid.push(p); validHandles.push(p.handle); }
        }
        if (!valid.length) { setList([]); showEmpty(); return; }
        if (valid.length !== list.length) { setList(validHandles); }

        /* Preserve "recent" order = same as localStorage insertion order */
        products = valid;
        byHandle = {};
        for (var j = 0; j < valid.length; j++) byHandle[valid[j].handle] = valid[j];

        var sorted = sortProducts(products, sortSel ? sortSel.value : 'recent');
        renderGrid(sorted);
      });
    }

    /* ===== Card-level actions ===== */
    grid && grid.addEventListener('click', function (e) {
      /* Remove (X) */
      var rm = e.target.closest('[data-wishlist-remove]');
      if (rm) {
        e.preventDefault();
        var handle = rm.getAttribute('data-wishlist-remove');
        var list = getList().filter(function (h) { return h !== handle; });
        setList(list);
        products = products.filter(function (p) { return p.handle !== handle; });
        delete byHandle[handle];
        var card = rm.closest('.wishlist-card');
        if (card) {
          card.classList.add('is-removing');
          setTimeout(function () {
            card.remove();
            if (countNum) countNum.textContent = list.length;
            if (!list.length) showEmpty();
            else renderGrid(sortProducts(products, sortSel ? sortSel.value : 'recent'));
          }, 300);
        }
        return;
      }

      /* In den Warenkorb (single variant) */
      var add = e.target.closest('[data-wishlist-add]');
      if (add) {
        e.preventDefault();
        if (add.getAttribute('data-state') === 'loading') return;
        var variantId = add.getAttribute('data-variant-id');
        if (!variantId) return;
        add.setAttribute('data-state', 'loading');
        var labelSpan = add.querySelector('span');
        var originalLabel = labelSpan ? labelSpan.textContent : '';
        if (labelSpan) labelSpan.textContent = (T.adding || 'Wird hinzugefügt…');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          add.setAttribute('data-state', 'added');
          if (labelSpan) labelSpan.textContent = '✓ Hinzugefügt';
          showToast((T.added_to_cart || 'Zum Warenkorb hinzugefügt'), 'success');
          /* Notify Prestige cart drawer */
          try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent('cart:item-added')); } catch (e) {}
          setTimeout(function () {
            add.removeAttribute('data-state');
            if (labelSpan) labelSpan.textContent = originalLabel;
          }, 1800);
        })
        .catch(function () {
          add.removeAttribute('data-state');
          if (labelSpan) labelSpan.textContent = originalLabel;
          showToast((T.add_failed || 'Hinzufügen fehlgeschlagen'), 'error');
        });
      }
    });

    /* ===== Sort change ===== */
    sortSel && sortSel.addEventListener('change', function () {
      if (!products.length) return;
      renderGrid(sortProducts(products, sortSel.value));
    });

    /* ===== Bulk add to cart ===== */
    bulkBtn && bulkBtn.addEventListener('click', function () {
      if (bulkBtn.getAttribute('data-state') === 'loading') return;
      var items = products
        .filter(function (p) {
          return p.available && Array.isArray(p.variants) && p.variants.length === 1 && p.variants[0].available;
        })
        .map(function (p) { return { id: p.variants[0].id, quantity: 1 }; });
      if (!items.length) return;
      bulkBtn.setAttribute('data-state', 'loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        bulkBtn.removeAttribute('data-state');
        showToast(items.length + (T.items_added_suffix || ' Artikel zum Warenkorb hinzugefügt'), 'success');
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('cart:item-added')); } catch (e) {}
      })
      .catch(function () {
        bulkBtn.removeAttribute('data-state');
        showToast((T.add_failed || 'Hinzufügen fehlgeschlagen'), 'error');
      });
    });

    /* ===== Share ===== */
    shareBtn && shareBtn.addEventListener('click', function () {
      var shareList = getList();
      var url = window.location.origin + window.location.pathname + (shareList.length ? '?list=' + shareList.map(encodeURIComponent).join(',') : '');
      var title = document.title || 'Meine Wunschliste';
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          showToast((T.link_copied || 'Link kopiert'), 'success');
        }).catch(function () { showToast((T.share_unavailable || 'Teilen nicht verfügbar'), 'error'); });
      } else {
        showToast((T.share_unavailable || 'Teilen nicht verfügbar'), 'error');
      }
    });

    /* ===== Clear all ===== */
    clearBtn && clearBtn.addEventListener('click', function () {
      if (!products.length) return;
      var ok = window.confirm((T.confirm_clear || 'Alle Artikel von der Wunschliste entfernen?'));
      if (!ok) return;
      setList([]);
      products = [];
      byHandle = {};
      showEmpty();
      showToast((T.cleared || 'Wunschliste geleert'), 'success');
    });

    /* ===== Cross-tab sync ===== */
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) load();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', load);
    } else {
      load();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
